var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"frame flex-col"},[_c('div',{staticClass:"frame-title"},[_c('div',{staticClass:"text"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")])]),_c('div',{staticClass:"flex-1 slotbox"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }